import { base } from '@modules';

import { AuditSchema } from './Audit.schema';

export const initialState: AuditSchema = {
  disclosure: { ...base.state, data: { ...base.paginagedState } },
  nullSubscriber: { ...base.state, data: { ...base.paginagedState } },
};
